import React, { Component } from 'react';
import * as CookieService from '../CookieService';
import * as RequestorApprovalAction from '../actions/RequestorApprovalAction';
import RequestorApprovalStore from '../stores/RequestorApprovalStore';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import { withTranslation, Trans } from 'react-i18next'
import swal from 'sweetalert';
import * as MenuAction from '../actions/MenuAction';
//let currentPagePath;
let selectedMultiItems;
let bFromEmailLink = true;
let sessionValues;
let approvalType = null;
let SingleLine = false;
let IsDecline = false;
let IsApproveClick = false;
class RequestorApprovalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Work_Order: "",
            declinereason: "Decline",
            labdeclinerea: "",
            subenable: "",
            checkboxline: "",
            submitlab: false,
            NextApprDet: { NextAprName: "", NextAprEmail: "", Order_No: "", WO: "" },
            headerdetails: {
                Chg_Emp_ID: "",
                Currency_Symbol: "",
                Employee_Name: "",
                Footer_Total: "",
                Machine_Number: "",
                Need_by_Date: "",
                Notes: "",
                SDI_Requisition_Number: "",
                Submit_Date: "",
                btnApprove: "",
                isWorkOrderEnable: "",
                Work_Order: "",
                lblChgCD: "",
                lblDBErr1: "",
                txtOrdByID: "",
                isFavorited: false,
                disabled_button: true,
                isLineClicked: true,
                showprice: (CookieService.getLocalStorageValues("Session_ShowPrice") == "1" && CookieService.getLocalStorageValues("Session_ISAPriceBlock") != "Y" ? "0" : "")
            },
            singlelinedetails: [],
            Linedetails: [],
            Item_Cat: "",
            errorMessage: "",
            appURL: "",
            Comments: "",
            inValidComments: false,
            reasonValue: "",
            approveLineItem: [],
            lineLevel: false,
            showPrice: false
        };
        this.assignReqApproval = this.assignReqApproval.bind(this);
        this.handleWorkOrder = this.handleWorkOrder.bind(this);
        this.handleQty = this.handleQty.bind(this);
        this.approveDeclineSingle = this.approveDeclineSingle.bind(this);
        this.handleCheckbox = this.handleCheckbox.bind(this);
        this.approveDeclineMultiple = this.approveDeclineMultiple.bind(this);
        this.singleLineResponse = this.singleLineResponse.bind(this);
        this.multiLineResponse = this.multiLineResponse.bind(this);
        this.ExceededOkClick = this.ExceededOkClick.bind(this);
        //this.loadFavPageResponse = this.loadFavPageResponse.bind(this);
        //this.handleFavorite = this.handleFavorite.bind(this);
    }
    IsFromEmailLink = () => {
        let isEmail = true;
        const queryParams = new URLSearchParams(window.location.search);
        const QS_src = queryParams.get('src');
        let Session_USERNAME = CookieService.getLocalStorageValues("Session_USERNAME") ? CookieService.getLocalStorageValues("Session_USERNAME") : "";
        if (QS_src) {
            if (QS_src.toLowerCase() == "needquote") {
                if (Session_USERNAME != "App Order Email Link" && Session_USERNAME != "App Quote Email Link") {
                    isEmail = false;
                }
            }
        }
        return isEmail;
    };
    setWebAppURL = () => {
        let cachedURL = sessionStorage.getItem("webAppURL");
        if (!cachedURL || cachedURL == "") {
            $.ajax({
                type: "GET",
                url: SDIConstants.localWebAPP
            }).then((data) => {
                this.setState({ appURL: data });
                console.log("ThroughCallWeb", data);
                sessionStorage.setItem("webAppURL", data);
            });
        } else {
            console.log("ThroughCacheWeb", sessionStorage.getItem("webAppURL"));
            this.setState({ appURL: sessionStorage.getItem("webAppURL") });
        }
    };
    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        bFromEmailLink = this.IsFromEmailLink();
        this.setWebAppURL();
        //if (bFromEmailLink == false) {
        //    currentPagePath = this.props.location.pathname;
        //    currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        //    let getFavPageBO = {
        //        Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
        //        pageURL: currentPagePath.toLowerCase()
        //    };
        //    RequestorApprovalAction.getCurrentFavPage(getFavPageBO);
        //}
        this.pageLoad();
        RequestorApprovalStore.on("requestorData", this.assignReqApproval);
        RequestorApprovalStore.on("single", this.singleLineResponse);
        RequestorApprovalStore.on("multi", this.multiLineResponse);
        RequestorApprovalStore.on("reason", this.ShowDecineReason);
        //RequestorApprovalStore.on('favpage', this.loadFavPageResponse);
        //RequestorApprovalStore.on('updateFavPage', this.updateFavPageResponse);
    };
    componentWillUnmount() {
        RequestorApprovalStore.removeListener("requestorData", this.assignReqApproval);
        RequestorApprovalStore.removeListener("single", this.singleLineResponse);
        RequestorApprovalStore.removeListener("multi", this.multiLineResponse);
        RequestorApprovalStore.removeListener("reason", this.ShowDecineReason);
    };

    HandleComments = (e) => {
        this.setState({ Comments: e.target.value, disabled_button: (this.state.reasonValue == "5" && e.target.value == "") || this.state.reasonValue == "" ? true : false })
    }

    pageLoad = () => {
        const urlParams = new URLSearchParams(window.location.search);
        let QS_fer = urlParams.get('fer');
        let QS_op = urlParams.get('op');
        let QS_xyz = urlParams.get('xyz');
        let QS_alt = urlParams.get('QS_alt');
        let LINE_FIELD_C6 = urlParams.get('LINE_FIELD_C6');
        const QS_ExchHome23 = urlParams.get('ExchHome23');
        if (bFromEmailLink == false) {
            if (QS_fer)
                QS_fer = decodeURIComponent(QS_fer);
            if (QS_op)
                QS_op = decodeURIComponent(QS_op);
            if (QS_xyz)
                QS_xyz = decodeURIComponent(QS_xyz);
            if (QS_alt)
                QS_alt = decodeURIComponent(QS_alt);
        } else {
            window.document.title = "Approve Quote";
        }
        let pageLoadBO = {
            QS_fer: QS_fer ? QS_fer : "",
            QS_op: QS_op ? QS_op : "",
            QS_xyz: QS_xyz ? QS_xyz : "",
            QS_alt: QS_alt ? QS_alt : "",
            QS_ExchHome23: QS_ExchHome23 ? QS_ExchHome23 : "",
            bFromEmailLink: bFromEmailLink,//bFromEmailLink,
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT") ? CookieService.getLocalStorageValues("Session_BUSUNIT") : "",
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID") ? CookieService.getLocalStorageValues("Session_UserID") : "",
            Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME") ? CookieService.getLocalStorageValues("Session_USERNAME") : "",
            Session_PUNCHIN: CookieService.getLocalStorageValues("Session_PUNCHIN") ? CookieService.getLocalStorageValues("Session_PUNCHIN") : "",
            Session_WorkOrderPnchInA: CookieService.getLocalStorageValues("Session_WorkOrderPnchInA") ? CookieService.getLocalStorageValues("Session_WorkOrderPnchInA") : "",
            Session_ValidateWorkOrder: CookieService.getLocalStorageValues("Session_ValidateWorkOrder") ? CookieService.getLocalStorageValues("Session_ValidateWorkOrder") : "",
            Session_CARTWOREQ: CookieService.getLocalStorageValues("Session_CARTWOREQ") ? CookieService.getLocalStorageValues("Session_CARTWOREQ") : "",
            LINE_FIELD_C6: LINE_FIELD_C6 ? LINE_FIELD_C6 : "",
        };
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (bFromEmailLink == false) {
            RequestorApprovalAction.getReqApprovals(pageLoadBO);
        } else {
            RequestorApprovalAction.getReqApprovalsUnauth(pageLoadBO);
        }
    };
    assignReqApproval = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let requestorData = JSON.parse(RequestorApprovalStore.requestorData);
        console.log("requestorData", requestorData);
        let flagData = requestorData.FlagDetails;
        let showPrice =false
        if (flagData.length > 0) {
            flagData = flagData[0];
            if (bFromEmailLink) {
                //WW-1248 Active/inactive approval flow -Vishwa S

                if (flagData && flagData.isUserInActive.toLowerCase() == "true") {
                    this.props.history.push({
                        pathname: "/",
                        origin: "APPROVALS",
                        phoneNo: flagData.helpDeskNo
                    });
                    return;
                }
                sessionValues = {
                    Session_ApprovalUserName: flagData.Session_ApprovalUserName,
                    Session_ExchHome2: flagData.Session_ExchHome2,
                    Session_RFApproveLikeAscend: flagData.Session_RFApproveLikeAscend,
                    Session_ApprovalDetails: flagData.Session_ApprovalDetails,
                    Session_USERNAME: "App Quote Email Link",
                    __siteCurrency: flagData.__siteCurrency,
                    Session_UserType: flagData.User_Type
                };
                // CookieService.insertLocalStorageValues(sessionValues);

            } else {
                CookieService.updateLocalStorageValues("Session_ApprovalUserName", flagData.Session_ApprovalUserName);
                CookieService.updateLocalStorageValues("Session_ExchHome2", flagData.Session_ExchHome2);
                CookieService.updateLocalStorageValues("Session_RFApproveLikeAscend", flagData.Session_RFApproveLikeAscend);
                CookieService.updateLocalStorageValues("Session_ApprovalDetails", flagData.Session_ApprovalDetails);
                CookieService.updateLocalStorageValues("__siteCurrency", flagData.__siteCurrency);
            }
            showPrice = flagData.ShowPrice && flagData.ShowPrice.toUpperCase() == "TRUE" ? true : false;
        };
        let headerdetails = requestorData.Headerdetails;

        if (requestorData.Linedetails.length > 0) {
            requestorData.Linedetails.forEach((row) => {
                row.chkLineItem = false;
                //Recommended supplier in description on requestor approval page and Unique Id's to UI elements - Deepthi 
                row.RecommendedSupplier = "";
                if (row.DESCR254.toUpperCase().includes("RECOMMENDED SUPPLIER")) {
                    let ind = row.DESCR254.toUpperCase().indexOf("RECOMMENDED SUPPLIER");
                    let recind = row.DESCR254.toUpperCase().indexOf(":");
                    let RecSuppStr = row.DESCR254.toUpperCase().substring(recind + 1, row.DESCR254.length);
                    row.RecommendedSupplier = RecSuppStr;
                    let removedreco = row.DESCR254.slice(0, ind);
                    row.DESCR254 = removedreco;
                }
                //WW-243 Supplier and label changes - A1QA-134 - Deepthi N H
                else if (row.DESCR254.toUpperCase().includes("SUPPLIER")) {
                    let ind = row.DESCR254.toUpperCase().indexOf("SUPPLIER");
                    let recind = row.DESCR254.toUpperCase().indexOf(":");
                    let RecSuppStr = row.DESCR254.toUpperCase().substring(recind + 1, row.DESCR254.length);
                    row.RecommendedSupplier = "";
                    let removedreco = row.DESCR254.slice(0, ind);
                    row.DESCR254 = removedreco;
                }
                else {
                    row.RecommendedSupplier = "";
                    row.DESCR254 = row.DESCR254;
                }
            });
        } else {
            this.props.history.push({
                pathname: '/needquote',
            });
        };
        let testline = requestorData.Linedetails[0].ISA_ITEM_CAT;
        this.setState({ Linedetails: requestorData.Linedetails, Item_Cat: requestorData.Linedetails[0].ISA_ITEM_CAT, showPrice: showPrice });

        if (headerdetails.length > 0) {
            headerdetails = headerdetails[0];
            this.setState({
                headerdetails: headerdetails,
                Work_Order: headerdetails.Work_Order,
            });
        };

        //'[09/22/22,WW-496_PC_2-Don't get data that has decline reason as null as we get data if IS_UPDATED is Y]Priyanka D 
        // selectedMultiItems = this.state.Linedetails.filter((x) => x.DECLINE_REASON == null)

        // this.setState({ Linedetails: selectedMultiItems });

        if (this.state.Linedetails.length == 0) {

            this.props.history.push({
                pathname: '/needquote',
            });
        }
    };

    handleWorkOrder = (event) => {
        this.setState({ Work_Order: event.target.value });
    };
    handleQty = (event, index) => {
        const re = SDIConstants.quantityRegEX;
        if (event.target.value === '' || re.test(event.target.value)) {
            if (event.target.value != "0") {
                let { Linedetails } = this.state;
                Linedetails[index].QTY_REQ = event.target.value;
                this.setState(Linedetails);
            }
        }
    };
    approveDeclineReqOrder = (lineItems, selectedLines, appDecType, singleMultiType) => {

        /**WAL-588 & WAL-573 ****(25/10/2021)*/

        approvalType = appDecType;
        let reason = $("#declreasondrop option:selected").text();
        let comments = this.state.Comments;
        const urlParams = new URLSearchParams(window.location.search);
        let QS_fer = urlParams.get('fer');
        let QS_op = urlParams.get('op');
        let QS_xyz = urlParams.get('xyz');
        let QS_alt = urlParams.get('QS_alt');
        let LINE_FIELD_C6 = urlParams.get('LINE_FIELD_C6')
        if (bFromEmailLink == false) {
            if (QS_fer)
                QS_fer = decodeURIComponent(QS_fer);
            if (QS_op)
                QS_op = decodeURIComponent(QS_op);
            if (QS_xyz)
                QS_xyz = decodeURIComponent(QS_xyz);
            if (QS_alt)
                QS_alt = decodeURIComponent(QS_alt);
        }
        let cookieValues;
        if (bFromEmailLink) {
            cookieValues = {
                Session_ApprovalUserName: sessionValues.Session_ApprovalUserName ? sessionValues.Session_ApprovalUserName : "",
                Session_ApprovalDetails: sessionValues.Session_ApprovalDetails ? sessionValues.Session_ApprovalDetails : "",
                Session_USERID: "",
                Session_BUSUNIT: "",
                Session_ITEMMODE: "",
                Session_IOLServer: "",
                Session_cplusServer: "",
                Session_SITEPREFIX: "",
                Session_ISABudgetaryLimit: "",
                Session_PUNCHIN: "",
                Session_UserType: sessionValues.Session_UserType ? sessionValues.Session_UserType : ""

            };
        } else {
            cookieValues = {
                Session_ApprovalUserName: CookieService.getLocalStorageValues("Session_ApprovalUserName") ? CookieService.getLocalStorageValues("Session_ApprovalUserName") : "",
                Session_ApprovalDetails: CookieService.getLocalStorageValues("Session_ApprovalDetails") ? CookieService.getLocalStorageValues("Session_ApprovalDetails") : "",
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID") ? CookieService.getLocalStorageValues("Session_UserID") : "",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT") ? CookieService.getLocalStorageValues("Session_BUSUNIT") : "",
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE") ? CookieService.getLocalStorageValues("Session_ITEMMODE") : "",
                Session_IOLServer: CookieService.getLocalStorageValues("Session_IOLServer") ? CookieService.getLocalStorageValues("Session_IOLServer") : "",
                Session_cplusServer: CookieService.getLocalStorageValues("Session_cplusServer") ? CookieService.getLocalStorageValues("Session_cplusServer") : "",
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX") ? CookieService.getLocalStorageValues("Session_SITEPREFIX") : "",
                Session_ISABudgetaryLimit: CookieService.getLocalStorageValues("Session_ISABudgetaryLimit") ? CookieService.getLocalStorageValues("Session_ISABudgetaryLimit") : "",
                Session_PUNCHIN: CookieService.getLocalStorageValues("Session_PUNCHIN") ? CookieService.getLocalStorageValues("Session_PUNCHIN") : "",
                Session_UserType: CookieService.getLocalStorageValues("Session_USERTYPE") ? CookieService.getLocalStorageValues("Session_USERTYPE") : "",
            }
        }
        let approveDeclineBO = {
            Session_USERID: cookieValues.Session_USERID,
            Session_BUSUNIT: cookieValues.Session_BUSUNIT,
            Session_ApprovalDetails: cookieValues.Session_ApprovalDetails,
            QS_fer: QS_fer ? QS_fer : "",
            QS_op: QS_op ? QS_op : "",
            QS_xyz: QS_xyz ? QS_xyz : "",
            QS_alt: QS_alt ? QS_alt : "",
            bFromEmailLink: bFromEmailLink,//bFromEmailLink,
            Session_ITEMMODE: cookieValues.Session_ITEMMODE,
            Session_IOLServer: cookieValues.Session_IOLServer,
            Session_cplusServer: cookieValues.Session_cplusServer,
            Session_SITEPREFIX: cookieValues.Session_SITEPREFIX,
            Session_ISABudgetaryLimit: cookieValues.Session_ISABudgetaryLimit,
            Session_PUNCHIN: cookieValues.Session_PUNCHIN,
            selectedLines: selectedLines,
            ReqLineItems: lineItems,
            txtWO_visible: this.state.headerdetails.isWorkOrderEnable,
            txtWO: this.state.Work_Order,
            lblWO: this.state.headerdetails.Work_Order,
            totalLineItems: this.state.Linedetails.length,
            Session_ApprovalUserName: cookieValues.Session_ApprovalUserName,
            LINE_FIELD_C6: this.state.Linedetails[0].LINE_FIELD_C6,
            User_Type: cookieValues.Session_UserType,
            DeclineReason: reason == " Select"? "": reason,
            Comments: comments,
            OrderNotes: {
                ISA_LINE_STATUS: appDecType == 1 ? "QSA" : "QSR",
                Line_NO: selectedLines,
                OrderNO: QS_fer,
                Ordernotes: comments
            },
        };

        $('#declinereason').modal('hide');
        $('#ApprovalComments').modal('hide');
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (appDecType == 1) {
            if (bFromEmailLink == false) {
                RequestorApprovalAction.approveSingleOrder(approveDeclineBO);
            } else {
                RequestorApprovalAction.approveSingleOrderUnAuth(approveDeclineBO);
            }
        } else {
            if (bFromEmailLink == false) {
                RequestorApprovalAction.declineSingleOrder(approveDeclineBO);
            } else {
                RequestorApprovalAction.declineSingleOrderUnAuth(approveDeclineBO);
            }
        }
    };
    singleLineResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let LineLevelCount = this.state.Linedetails.length;
        let singleAppDecRes = JSON.parse(RequestorApprovalStore.singleAppDecRes)[0];
        if (singleAppDecRes.Status == "Success") {
            if (SingleLine) {
                if (singleAppDecRes.Type == "Approve") {
                    if (!singleAppDecRes.IsLastLine) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Item has been approved successfully"
                        });
                        if (LineLevelCount == 1) {
                            this.props.history.push({
                                pathname: '/needquote',
                            });
                            return false;
                        }
                        MenuAction.refreshMasterData()
                        this.pageLoad();
                    }
                    else {

                        if (singleAppDecRes.IsExceeded == "True") {


                            let NextApprDets = {
                                NextAprName: singleAppDecRes.Approver_Name, NextAprEmail: singleAppDecRes.Approver_Mail,
                                Order_No: singleAppDecRes.Order_No, WO: singleAppDecRes.WO
                            }
                            this.setState({ NextApprDet: NextApprDets });

                            $('#limit-exceeded').modal('show');




                        }
                        else {
                            if (singleAppDecRes.IsLastLine == "True") {
                                swal({
                                    allowOutsideClick: false,
                                    closeOnClickOutside: false,
                                    text: "Order successfully approved"
                                });
                            }
                            else {
                                swal({
                                    allowOutsideClick: false,
                                    closeOnClickOutside: false,
                                    text: "Item has been approved successfully"
                                });
                            }
                            if (LineLevelCount == 1) {
                                this.props.history.push({
                                    pathname: '/needquote',
                                });
                                return false;
                            }
                            MenuAction.refreshMasterData()
                            this.pageLoad();
                        }
                    }

                }
                else {
                    if (singleAppDecRes.IsLastLine == "") {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Oops! Something went wrong"
                        });
                    }
                    else if (singleAppDecRes.IsLastLine == "False") {
                        if (IsDecline) {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Item has been declined successfully"
                            });
                        }
                        else {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Decline reason has been updated successfully"
                            });
                        }
                        if (LineLevelCount == 1) {
                            MenuAction.refreshMasterData()
                            this.props.history.push({
                                pathname: '/needquote',
                            });
                            return false;
                        }
                        else {
                            MenuAction.refreshMasterData()
                            this.pageLoad();
                        }

                    }
                    else {
                        if (IsDecline) {
                            let NextApprDets = {
                                NextAprName: singleAppDecRes.Approver_Name, NextAprEmail: singleAppDecRes.Approver_Mail,
                                Order_No: singleAppDecRes.Order_No, WO: singleAppDecRes.WO
                            }
                            this.setState({ NextApprDet: NextApprDets })
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Item has been declined successfully"
                            }).then(() => {
                                if (singleAppDecRes.IsExceeded == "True") {
                                    $('#limit-exceeded').modal('show');
                                }
                                else {
                                    if (LineLevelCount == 1) {
                                        this.props.history.push({
                                            pathname: '/needquote',
                                        });
                                        return false;
                                    }
                                    else {
                                        this.pageLoad();
                                    }

                                }
                            })
                        }
                        else {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Decline reason has been updated successfully"
                            });
                            if (LineLevelCount == 1) {
                                MenuAction.refreshMasterData()
                                this.props.history.push({
                                    pathname: '/needquote',
                                });
                                return false;
                            }
                            else {
                                MenuAction.refreshMasterData()
                                this.pageLoad();
                            }

                        }

                    }
                }

            }
            else {
                let TxtMsg = "";
                let SelectedLines = this.state.Linedetails.filter((x) => x.chkLineItem == true);

                if (singleAppDecRes.Type == "Approve") {
                    if (SelectedLines.length > 1) {
                        TxtMsg = "Selected lines are approved successfully"
                    }
                    else {
                        TxtMsg = "Selected line is approved successfully"
                    }
                    if (singleAppDecRes.IsLastLine == "") {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Oops! Something went wrong"
                        });
                    }
                    else if (singleAppDecRes.IsLastLine == "False") {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: TxtMsg
                        });
                        if (bFromEmailLink == true) {
                            if (selectedMultiItems.length == this.state.Linedetails.length) {
                                window.location.href = this.state.appURL;
                            }
                            this.pageLoad();
                        }
                        else {
                            if (selectedMultiItems.length == this.state.Linedetails.length) {
                                MenuAction.refreshMasterData()
                                this.props.history.push({
                                    pathname: '/needquote',
                                });
                            }
                            else {
                                MenuAction.refreshMasterData();
                                this.pageLoad();
                            }

                        }
                    }
                    else {
                        if (singleAppDecRes.IsExceeded == "True") {
                            let NextApprDets = {
                                NextAprName: singleAppDecRes.Approver_Name, NextAprEmail: singleAppDecRes.Approver_Mail,
                                Order_No: singleAppDecRes.Order_No, WO: singleAppDecRes.WO
                            }
                            this.setState({ NextApprDet: NextApprDets });
                            $('#limit-exceeded').modal('show');
                        }
                        else {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: TxtMsg
                            });
                            if (bFromEmailLink == true) {
                                if (selectedMultiItems.length == this.state.Linedetails.length) {
                                    window.location.href = this.state.appURL;
                                }
                                this.pageLoad();
                            }
                            else {
                                if (selectedMultiItems.length == this.state.Linedetails.length) {
                                    MenuAction.refreshMasterData();
                                    this.props.history.push({
                                        pathname: '/needquote',
                                    });
                                }
                                else {
                                    MenuAction.refreshMasterData();
                                    this.pageLoad();
                                }
                            }
                        }
                    }
                }
                else {
                    if (SelectedLines.length > 1) {
                        TxtMsg = "Selected lines are declined successfully"
                    }
                    else {
                        TxtMsg = "Selected line is declined successfully"
                    }
                    if (singleAppDecRes.IsLastLine == "") {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Oops! Something went wrong"
                        });
                    }
                    else if (singleAppDecRes.IsLastLine == "False") {
                        if (this.state.declinereason == "Decline") {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: TxtMsg
                            });
                        }
                        else {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Decline reason has been updated successfully"
                            });
                        }

                        if (bFromEmailLink == true) {
                            if (selectedMultiItems.length == this.state.Linedetails.length) {
                                window.location.href = this.state.appURL;
                            }
                            this.pageLoad();
                        }
                        else {
                            if (selectedMultiItems.length == this.state.Linedetails.length) {
                                this.props.history.push({
                                    pathname: '/needquote',
                                });
                            };
                            this.pageLoad();
                        }
                    }
                    else {
                        if (IsDecline) {
                            let NextApprDets = {
                                NextAprName: singleAppDecRes.Approver_Name, NextAprEmail: singleAppDecRes.Approver_Mail,
                                Order_No: singleAppDecRes.Order_No, WO: singleAppDecRes.WO
                            }
                            this.setState({ NextApprDet: NextApprDets })
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: TxtMsg
                            }).then(function () {
                                if (singleAppDecRes.IsExceeded == "True") {
                                    $('#limit-exceeded').modal('show');
                                }
                            })
                            if (singleAppDecRes.IsExceeded == "False") {
                                if (bFromEmailLink == true) {
                                    if (selectedMultiItems.length == this.state.Linedetails.length) {
                                        window.location.href = this.state.appURL;
                                    }
                                    this.pageLoad();
                                }
                                else {
                                    if (selectedMultiItems.length == this.state.Linedetails.length) {
                                        this.props.history.push({
                                            pathname: '/needquote',
                                        });
                                    };
                                    this.pageLoad();
                                }
                            }
                        }
                        else {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Decline reason has been updated successfully"
                            });
                            if (bFromEmailLink == true) {
                                if (selectedMultiItems.length == this.state.Linedetails.length) {
                                    window.location.href = this.state.appURL;
                                }
                                this.pageLoad();
                            }
                            else {
                                if (selectedMultiItems.length == this.state.Linedetails.length) {
                                    this.props.history.push({
                                        pathname: '/needquote',
                                    });
                                };
                                this.pageLoad();
                            }
                        }

                    }
                }

            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Oops! Something went wrong"
            });
        }

    };

    multiLineResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let multiAppDecRes = JSON.parse(RequestorApprovalStore.multiAppDecRes)[0];

        console.log("multiAppDecRes", multiAppDecRes);
        if (multiAppDecRes.strApproveString) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: `${multiAppDecRes.strApproveString}`
            });
            //  alert(`${multiAppDecRes.strApproveString}`);
        }
        if (multiAppDecRes.bSuccess.toLowerCase() == "true") {

            if (bFromEmailLink == true) {
                //[15/08/23, 3791 - Commented the if condition to check if length of selectedMultiItems is equal to length of Linedetails, Vishwa S]
                //if (selectedMultiItems.length == this.state.Linedetails.length) {
                if (approvalType == 1) {

                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Selected items has been approved successfully"
                    })
                    // alert("Selected items has been approved successfully");
                } else {
                    ;
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Selected items has been declined successfully"
                    });
                    //  alert("Selected items has been declined successfully");
                }
                //[15 / 08 / 23, 3791 - Create a if condition to check if length of selectedMultiItems is equal to length of Linedetails, Vishwa S]
                if (selectedMultiItems.length == this.state.Linedetails.length) {
                    window.location.href = this.state.appURL;
                }
                //[15 / 08 / 23, 3791 - Invoke the pageLoad method, Vishwa S]
                this.pageLoad();
                //};

            } else {

                if (approvalType == 1) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Selected items has been approved successfully"
                    });
                    //  alert("Selected items has been approved successfully");
                } else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Selected items has been declined successfully"
                    });
                    //  alert("Selected items has been declined successfully");
                }
                if (selectedMultiItems.length == this.state.Linedetails.length) {
                    this.props.history.push({
                        pathname: '/needquote',
                    });
                };
                this.pageLoad();
            }
        } else {
            if (multiAppDecRes.lblMsgrslt) {
                this.setState({ errorMessage: multiAppDecRes.lblMsgrslt });
            } else if (multiAppDecRes.lblDBErr1_Visible.toLowerCase() == "true") {
                this.setState({ errorMessage: multiAppDecRes.lblDBErr1 });
            } else if (multiAppDecRes.lblDBErr_Visible.toLowerCase() == "true") {
                this.setState({ errorMessage: multiAppDecRes.lblDBErr });
            }
        }

    };
    approveDeclineSingle = (lineItemDetail, type) => {

        /**WAL-588 & WAL-573 ****(25/10/2021)*/
        const urlParams = new URLSearchParams(window.location.search);
        let LINE_FIELD_C6 = urlParams.get('LINE_FIELD_C6');
        console.log("LINE_FIELD_C6", LINE_FIELD_C6)
        /*NEW***(4/12/2021)***lblPrice-->PRICE_VNDR*/
        let lineItems = [];
        let selectedLines = [];
        SingleLine = true;
        if (type == "2") {
            IsApproveClick = false;
            lineItems.push({
                chkLineItem: true,
                LINE_NBR: lineItemDetail[0].LINE_NBR,
                lblPrice: lineItemDetail[0].PRICE_VNDR,
                txtQTY: lineItemDetail[0].QTY_REQ,
                lblDueDt: lineItemDetail[0].lblDueDt,
                DUE_DT: lineItemDetail[0].DUE_DT,
                ISA_ORDER_STATUS: lineItemDetail[0].ISA_ORDER_STATUS,
                ltrItemNo: lineItemDetail[0].ltrItemNo,
                INV_STOCK_TYPE: lineItemDetail[0].INV_STOCK_TYPE,
                CURRENCY_CD: lineItemDetail[0].CURRENCY_CD,
                Description: lineItemDetail[0].DESCR254,
                UOM: lineItemDetail[0].UNIT_OF_MEASURE,
                ISAMFG_FREEFORM: lineItemDetail[0].ISA_MFG_FREEFORM,
                MFGITM_ID: lineItemDetail[0].MFG_ITM_ID,
                ISA_CUST_CHARGE_CD: lineItemDetail[0].ISA_CUST_CHARGE_CD,
                QTY_REQ_ORIG: lineItemDetail[0].QTY_REQ_ORIG,
                LINE_FIELD_C6: LINE_FIELD_C6,
                Item_Cat: lineItemDetail[0].ISA_ITEM_CAT,
            });
            selectedLines.push(lineItemDetail[0].LINE_NBR);
        }
        else {
            IsApproveClick = true;
            lineItems.push({
                chkLineItem: true,
                LINE_NBR: lineItemDetail.LINE_NBR,
                lblPrice: lineItemDetail.PRICE_VNDR,
                txtQTY: lineItemDetail.QTY_REQ,
                lblDueDt: lineItemDetail.lblDueDt,
                DUE_DT: lineItemDetail.DUE_DT,
                ISA_ORDER_STATUS: lineItemDetail.ISA_ORDER_STATUS,
                ltrItemNo: lineItemDetail.ltrItemNo,
                INV_STOCK_TYPE: lineItemDetail.INV_STOCK_TYPE,
                CURRENCY_CD: lineItemDetail.CURRENCY_CD,
                Description: lineItemDetail.DESCR254,
                UOM: lineItemDetail.UNIT_OF_MEASURE,
                ISAMFG_FREEFORM: lineItemDetail.ISA_MFG_FREEFORM,
                MFGITM_ID: lineItemDetail.MFG_ITM_ID,
                ISA_CUST_CHARGE_CD: lineItemDetail.ISA_CUST_CHARGE_CD,
                QTY_REQ_ORIG: lineItemDetail.QTY_REQ_ORIG,
                LINE_FIELD_C6: LINE_FIELD_C6,
                Item_Cat: lineItemDetail.ISA_ITEM_CAT

            });
            selectedLines.push(lineItemDetail.LINE_NBR);
        }

        this.approveDeclineReqOrder(lineItems, selectedLines, type, 1);
    };
    approveDeclineMultiple = (type) => {
        /**WAL-588 & WAL-573 ****(25/10/2021)*/
        SingleLine = false;
        const urlParams = new URLSearchParams(window.location.search);
        let LINE_FIELD_C6 = urlParams.get('LINE_FIELD_C6');
        selectedMultiItems = [];  /*NEW***(4/12/2021)***lblPrice-->PRICE_VNDR*/

        selectedMultiItems = this.state.Linedetails.filter((x) => x.chkLineItem == true);
        if (selectedMultiItems.length > 0) {
            let lineItems = [];
            let selectedLines = [];
            selectedMultiItems.forEach((lineItemDetail) => {
                lineItems.push({
                    chkLineItem: true,
                    LINE_NBR: lineItemDetail.LINE_NBR,
                    lblPrice: lineItemDetail.PRICE_VNDR,
                    txtQTY: lineItemDetail.QTY_REQ,
                    lblDueDt: lineItemDetail.lblDueDt,
                    DUE_DT: lineItemDetail.DUE_DT,
                    ISA_ORDER_STATUS: lineItemDetail.ISA_ORDER_STATUS,
                    ltrItemNo: lineItemDetail.ltrItemNo,
                    INV_STOCK_TYPE: lineItemDetail.INV_STOCK_TYPE,
                    CURRENCY_CD: lineItemDetail.CURRENCY_CD,
                    Description: lineItemDetail.DESCR254,
                    UOM: lineItemDetail.UNIT_OF_MEASURE,
                    ISAMFG_FREEFORM: lineItemDetail.ISA_MFG_FREEFORM,
                    MFGITM_ID: lineItemDetail.MFG_ITM_ID,
                    ISA_CUST_CHARGE_CD: lineItemDetail.ISA_CUST_CHARGE_CD,
                    QTY_REQ_ORIG: lineItemDetail.QTY_REQ_ORIG,
                    LINE_FIELD_C6: LINE_FIELD_C6,
                    Item_Cat: lineItemDetail.ISA_ITEM_CAT

                });
                selectedLines.push(lineItemDetail.LINE_NBR);

            });

            this.approveDeclineReqOrder(lineItems, selectedLines, type, 2);
        } else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select any line items to approve"
            });
            //   alert("Please select line items to Approve/Decline");
        }

    };
    handleCheckbox = (index) => {
        let { Linedetails } = this.state;
        Linedetails[index].chkLineItem = Linedetails[index].chkLineItem == true ? false : true;
        this.setState(Linedetails);
    };
    Deconclick = (lineItem, indexVal) => {

        $('#declinereason').modal('show');
        let linedata = [];
        linedata.push(lineItem)

        this.state.singlelinedetails.push(lineItem);
        this.setState({ checkboxline: indexVal, disabled_button: true, singlelinedetails: linedata, isLineClicked: true, Comments: "", inValidComments: false });
    };


    declinemultipleclick = (indexVal) => {
        let checkbox = []
        checkbox = this.state.Linedetails.filter((x) => x.chkLineItem == true);
        if (checkbox == 0 || checkbox == undefined) {

            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select any line items to decline"
            });
            // alert("Please Select Any Line Items To Decline")
        }
        else {
            $('#declinereason').modal('show');
        }
        this.setState({ disabled_button: true, isLineClicked: false, Comments: "", inValidComments: false });
    };



    HandleBtnTextchange = (event) => {

        if (event.target.value == '' || event.target.value == "0" || (event.target.value == "5" && this.state.Comments == "")) {
            this.state.disabled_button = true;
        }
        else {
            this.state.disabled_button = false;
        }
        if (event.target.value == "5" || event.target.value == "0") {
            IsDecline = true;
        }
        else {
            IsDecline = false;
        }
        this.setState({ reasonValue: event.target.value, declinereason: IsDecline ? "Decline" : "Submit", inValidComments: false })

    };
    cancelclick = (event) => {
        document.getElementById("declreasondrop").value = "0"
        document.getElementById("decreasoncmt").value = ""
        this.setState({ declinereason: "Decline", Comments: "", reasonValue: "", inValidComments: false })
    };
    ExceededOkClick = () => {
        if (IsApproveClick) {
            $('#limit-exceeded').modal('hide');
            this.props.history.push({
                pathname: '/needquote',
            });
        }
        else {
            if (SingleLine) {
                if (this.state.Linedetails.length == 1) {
                    this.props.history.push({
                        pathname: '/needquote',
                    });
                    return false;
                }
                this.pageLoad();
            }
            else {
                if (bFromEmailLink == true) {
                    if (selectedMultiItems.length == this.state.Linedetails.length) {
                        window.location.href = this.state.appURL;
                    }
                    this.pageLoad();
                }
                else {
                    if (selectedMultiItems.length == this.state.Linedetails.length) {
                        this.props.history.push({
                            pathname: '/needquote',
                        });
                    };
                    this.pageLoad();
                }
            }
        }
    }
    HandleDecSubClick = (lineItem) => {

        if (this.state.reasonValue == "5" && this.state.Comments.length < 5) {
            this.setState({ inValidComments: true })
        }
        else {
            if (this.state.isLineClicked == true) {
                this.approveDeclineSingle(this.state.singlelinedetails, 2)
                $('#declinereason').modal('hide');
            }
            else {
                this.approveDeclineMultiple(2);
                $('#declinereason').modal('hide');
            }
            this.cancelclick();
        }
    };
    UpdatemultipleDeclineReason = (selectedMultiItems, decreason, comments, ) => {
        let selectedLines = []
        selectedMultiItems.forEach((val, index) => {

            let Obj = {
                ORDER_NO: val.ORDER_NO,
                LINE_NBR: val.LINE_NBR
            }
            selectedLines.push(Obj);

        })

        let DeclineReasonBO = {
            DeclineReason: decreason,
            ItemDetails: selectedLines,
            Comments: comments
        };






        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        RequestorApprovalAction.DeclineReason(DeclineReasonBO);


    }
    UpdateDeclineReason = (lineItem, decreason, comments) => {
        let selectedLines = []


        let Obj = {
            ORDER_NO: lineItem[0].ORDER_NO,
            LINE_NBR: lineItem[0].LINE_NBR
        }
        selectedLines.push(Obj);

        let DeclineReasonBO = {
            DeclineReason: decreason,
            ItemDetails: selectedLines,
            Comments: comments
        };






        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        RequestorApprovalAction.DeclineReason(DeclineReasonBO);
    };
    ShowDecineReason = () => {

        let { Linedetails } = this.state;
        Linedetails.forEach((val, index) => {
            Linedetails[index].chkLineItem = Linedetails[index].chkLineItem == false;
        })
        this.setState(Linedetails);
        let data = JSON.parse(RequestorApprovalStore.bsucess);
        let result = data.Table1[0].lblDBErr1
        if (result == "Successfully Inserted") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Decline reason updated successfully"
            });
            //  alert("Reason Updated Successfully");
            this.pageLoad()
        }
        else {
            this.setState({ errorMessage: data.lblDBErr1 })
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
        // this.chkLineItem = 
    };

    //  /**
    //* Listener method for the response of Save/Delete favorite page
    //*/
    //  updateFavPageResponse = () => {
    //      if (RequestorApprovalStore.updateFavPageResponse.updateType == 1) {
    //          let response = JSON.parse(RequestorApprovalStore.updateFavPageResponse.responseStr)[0];
    //          if (response.is_Success == "True") {
    //              this.setState({ isFavorited: true })
    //          }
    //      } else {
    //          let response = JSON.parse(RequestorApprovalStore.updateFavPageResponse.responseStr)[0];
    //          if (response.success == "true") {
    //              this.setState({ isFavorited: false })
    //          }
    //      }
    //  };
    //  /**
    //  * Handle change method for favorite page checkbox
    //  * @param event
    //  */
    //  handleFavorite = (event) => {
    //      this.setState({ isFavorited: event.target.checked });

    //      if (event.target.checked == true) {
    //          let insertFavPageBO = {
    //              Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
    //              pageURL: currentPagePath.toLowerCase(),
    //              pageTitle: "Request Approvals"
    //          }
    //          RequestorApprovalAction.insertFavPage(insertFavPageBO)
    //      } else {
    //          let deleteFavPageBO = {
    //              Page_ID: this.state.Page_ID
    //          }
    //          RequestorApprovalAction.deleteFavPage(deleteFavPageBO)
    //      }
    //  };
    //  /**
    //  * Listener method for loading favorite page icon
    //  */
    //  loadFavPageResponse = () => {
    //      let favPageResponse = JSON.parse(RequestorApprovalStore.currentFavPageResponse);
    //      if (favPageResponse.length > 0) {
    //          favPageResponse = favPageResponse[0];
    //          this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
    //      };
    //  };
    //***********************New*(4/16/2021)*****************************
    OrderTotalCal = (Price, Quantity) => {
        //let SiteCurrency = this.state.SiteCurrencyTable;
        let ItemTotal = 0;
        let OrderTotal = 0;

        let uniteprice = parseFloat(Price) ? parseFloat(Price) : 0
        let QuantityAvail = parseFloat(Quantity) ? parseFloat(Quantity) : 0
        if (uniteprice != NaN && QuantityAvail != NaN && uniteprice != 0 && QuantityAvail != 0) {
            ItemTotal = uniteprice * QuantityAvail;
            //ItemTotal = uniteprice;
        }
        OrderTotal = OrderTotal + ItemTotal;
        let roundOffvalue = OrderTotal.toFixed(2)
        return ("$ " + roundOffvalue + " USD");



    }

    //*********************end***********************************

    bindReqApprovals = () => {
        let { showprice } = this.state;  /*NEW***(4/12/2021)***showprice added*/
        showprice = (CookieService.getLocalStorageValues("Session_ShowPrice") == "1" && CookieService.getLocalStorageValues("Session_ISAPriceBlock") != "Y" ? "0" : "")
        //WW-243_PC_NONCAT_01 showing itemid(2/10/2022) -Aparna
        let itemno = 0
        return this.state.Linedetails.map((lineItem, indexVal) => {
            let itemid = lineItem.ltrItemNo
            if (itemid.trim() == "") {
                itemno = itemno + 1
                itemid = "NONCAT-" + itemno
            }

            const { t } = this.props;
            console.log("lineItem.DECLINE_REASON", lineItem.DECLINE_REASON)
            return (
                <div className="accordian-inner-details p-4 my-3" key={lineItem.ORDER_NO + "-" + lineItem.LINE_NBR}>
                    <div className="d-flex align-items-center">
                        <div className="custom-control custom-checkbox item-custom-control">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id={`req-${indexVal}`}
                                name={`reqName-${indexVal}`}
                                checked={lineItem.chkLineItem}
                                onClick={() => this.handleCheckbox(indexVal)}
                            />
                            <label className="custom-control-label" htmlFor={`req-${indexVal}`} />
                        </div>
                        <div className="w-100 ml-4">
                            <p className="accordian-item-description item-details-value font-14 mt-3 mb-3 w-100 notif-section">
                                <label className="font-medium mb-0 font-14" id={`Desc${lineItem.DESCR254}${lineItem.ORDER_NO}-${lineItem.LINE_NBR}id`}>Description </label>
                                {`: ${lineItem.DESCR254}`}
                            </p>
                            <div className="row">
                                <div className="col-12 col-md-4">
                                    <div className="accordian-item-data mb-3">
                                        <label className="font-medium mb-0 font-14">{t("ID")}</label>
                                        <span className="value font-14 item-details-value" id={`ID${lineItem.ltrItemNo}${lineItem.ORDER_NO}-${lineItem.LINE_NBR}id`}>
                                            {`: ${itemid}`}
                                        </span>
                                    </div>
                                    <div className="accordian-item-data mb-3">
                                        <label className="font-medium mb-0 font-14">{t("Manufacturer")} {t("Part Number")}</label>
                                        <span className="value font-14 item-details-value" id={`SupPartNo${lineItem.MFG_ITM_ID}${lineItem.ORDER_NO}-${lineItem.LINE_NBR}id`}>
                                            {`: ${lineItem.MFG_ITM_ID}`}
                                        </span>
                                    </div>
                                    <div className="accordian-item-data mb-3">
                                        <label className="font-medium mb-0 font-14">{t("Delivery Date")}</label>
                                        <span className="value font-14 item-details-value" id={`SupName${lineItem.lblDueDt}${lineItem.ORDER_NO}-${lineItem.LINE_NBR}id`}>{`: ${lineItem.lblDueDt}`}</span>
                                    </div>
                                    <div className="accordian-item-data mb-3">
                                        <label className="font-medium mb-0 font-14">{t("Supplier Part#")}</label>
                                        <span className="value font-14 item-details-value" id={`SupPartNo${lineItem.SUPPLIER_PART_NUMBER}${lineItem.ORDER_NO}-${lineItem.LINE_NBR}id`}>
                                            {`: ${lineItem.SUPPLIER_PART_NUMBER}`}
                                        </span>
                                    </div>
                                    {lineItem.DECLINE_REASON != null ?
                                    <div className="accordian-item-data mb-3">
                                        <label className="font-medium mb-0 font-14">Decline Reason</label>
                                            <span className="value font-14 item-details-value" id={`SupName${lineItem.DECLINE_REASON}${lineItem.ORDER_NO}-${lineItem.LINE_NBR}id`}>{`: ${lineItem.DECLINE_REASON}`}</span>
                                    </div>
                                     : null}
                                </div>
                                <div className="col-12 col-md-4">
                                    <div className="accordian-item-data mb-3">
                                        <label className="font-medium mb-0 font-14">
                                            {t("Manufacturer")}
                                        </label>
                                        <span className="value font-14 item-details-value" id={`UOM${lineItem.ISA_MFG_FREEFORM}${lineItem.ORDER_NO}-${lineItem.LINE_NBR}id`}>{`: ${lineItem.ISA_MFG_FREEFORM}`}</span>
                                    </div>
                                    <div className="accordian-item-data mb-3">
                                        <label className="font-medium mb-0 font-14">{t("unitofmeasure_key")}</label>
                                        <span className="value font-14 item-details-value" id={`DueDate${lineItem.UNIT_OF_MEASURE}${lineItem.ORDER_NO}-${lineItem.LINE_NBR}id`}>{`: ${lineItem.UNIT_OF_MEASURE}`}</span>
                                    </div>
                                    <div className="accordian-item-data mb-3">
                                        <label className="font-medium mb-0 font-14">{t("Supplier Name")}</label>
                                        <span className="value font-14 item-details-value" id={`DueDate${lineItem.SUPPLIER_NAME}${lineItem.ORDER_NO}-${lineItem.LINE_NBR}id`}>{`: ${lineItem.SUPPLIER_NAME}`}</span>
                                    </div>
                                    {lineItem.RecommendedSupplier != "" ?
                                        <div className="accordian-item-data mb-3">
                                        <label className="font-medium mb-0 font-14">Recommended Supplier</label>
                                            <span className="value font-14 item-details-value" id={`SupName${lineItem.RecommendedSupplier}${lineItem.ORDER_NO}-${lineItem.LINE_NBR}id`}>{`: ${lineItem.RecommendedSupplier}`}</span>
                                        </div>
                                    : null}
                                </div>
                                <div className="col-12 col-md-4">
                                    {this.state.showPrice ? <div className="accordian-item-data mb-3 text-right">
                                        <label className="font-medium mb-0 font-14">{t("Item base price")}</label>
                                        <span className="value font-14 item-details-value">
                                            {`: $ ${lineItem.NET_UNIT_PRICE ? lineItem.NET_UNIT_PRICE.toFixed(2) : lineItem.NET_UNIT_PRICE} USD`}
                                        </span>
                                    </div> : null}
                                    <div className="accordian-item-data mb-3 text-right">
                                        <label className="font-medium mb-0 font-14">{t("Item qty")}</label>
                                        <span className="value font-14 item-details-value">
                                            {`: ${lineItem.QTY_REQ}`}
                                        </span>
                                    </div>
                                    {this.state.showPrice ? <div className="accordian-item-data mb-3 text-right">
                                        <label className="font-medium mb-0 font-14">{t("Ext price")}</label>
                                        <span className="value font-14 item-details-value">
                                            {`: ${this.OrderTotalCal(lineItem.NET_UNIT_PRICE, lineItem.QTY_REQ)}`}
                                        </span>
                                    </div> : null}
                                </div>
                            </div>
                            <div className="d-flex justify-content-end">
                                <button type="button" className="btn decline-btn font-medium" onClick={() => this.Deconclick(lineItem, indexVal)}>
                                    <img className="mr-1" src="/images/close.png" /> {t("Decline")}
                                </button>
                                <button type="button" className="btn approve-btn font-medium" onClick={() => this.approveClick(lineItem, true, true)}>
                                    <img className="mr-1" src="/images/tick.png" /> {t("Approve")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            );
        });

    }/******float-right mt-2 w-100******/

    approveClick = (lineItem, lineLevel, popUp) => {
        //5766 - check any line item is checked if not alert and return from the func [4/25/2025] Nachiappan
        let checkbox = []
        checkbox = this.state.Linedetails.filter((x) => x.chkLineItem == true);
        if (checkbox == 0 || checkbox == undefined) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select any line items to approve"
            });
            return;
        }
        if (popUp) {
            $('#ApprovalComments').modal('show');
            this.setState({ approveLineItem: lineItem, lineLevel: lineLevel, Comments: "", inValidComments: false })
        }
        else {
            if (this.state.lineLevel) {
                this.approveDeclineSingle(this.state.approveLineItem, 1)
            }
            else {
                this.approveDeclineMultiple(1)
            }
        }
    }
    closeCommentsPopup = () => {
        this.setState({ Comments: "", inValidComments: false})
    }
    render() {
        const { t } = this.props;
        console.log("ReqApprovGrid", this.state.headerdetails);
        return (
            <div>

                <div className="container-fluid content-section req-margin" >
                    <div className="row">
                        {/* Requestor Approval starts */}
                        <div className="container-fluid content-margin" id="containerfulldiv">
                            <div className="row">
                                <div className="col-md-12 page-heading mb-3">
                                    <h5 className="page-title">{t("r_a")}</h5>
                                    {/*<div className="fav-item-maintenance-icon mt-1">
                                    <input type="checkbox" id="checkbox-1" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                    <label htmlFor="checkbox-1">
                                        <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                            <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                <g className="grp7" opacity={0} transform="translate(7 6)">
                                                    <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                    <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                </g>
                                                <g className="grp6" opacity={0} transform="translate(0 28)">
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                </g>
                                                <g className="grp3" opacity={0} transform="translate(52 28)">
                                                    <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                    <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                </g>
                                                <g className="grp2" opacity={0} transform="translate(44 6)">
                                                    <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp5" opacity={0} transform="translate(14 50)">
                                                    <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp4" opacity={0} transform="translate(35 50)">
                                                    <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp1" opacity={0} transform="translate(24)">
                                                    <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                    <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                </g>
                                            </g>
                                        </svg>
                                    </label>
                                </div>*/}
                                </div>
                                <div className="col-lg-12">
                                    <div className="row border-bottom mb-4">
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="row">
                                                <label className="col-md-5 catalog-label">SDI {t("Requisition")} {t("Number")}</label>
                                                <label className="col-md-7 item-details-value" id={`ReqNum${this.state.headerdetails.SDI_Requisition_Number}id`}>{this.state.headerdetails.SDI_Requisition_Number}</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="row">
                                                <label className="col-md-5 catalog-label">{t("Employee")} {t("ID")}</label>
                                                <label className="col-md-7 item-details-value" id={`EmpId${this.state.headerdetails.Chg_Emp_ID}${this.state.headerdetails.txtOrdByID}id`}>{this.state.headerdetails.txtOrdByID}</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="row">
                                                <label className="col-md-5 catalog-label">{t("Employee")} {t("Full Name")}</label>
                                                <label className="col-md-7 item-details-value" id={`EmpName${this.state.headerdetails.Employee_Name}${this.state.headerdetails.SDI_Requisition_Number}id`}>{this.state.headerdetails.Employee_Name}</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="row">
                                                <label className="col-md-5 catalog-label">{t("workorder_key")} #</label>
                                                <label className="col-md-7">
                                                    {this.state.headerdetails.isWorkOrderEnable == "True" ? <input type="text" className="form-control w-75" placeholder={t("Please enter")} id={`WorkOrder${this.state.Work_Order}${this.state.headerdetails.SDI_Requisition_Number}id`} value={this.state.Work_Order} onChange={this.handleWorkOrder} /> : this.state.headerdetails.Work_Order}
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="row">
                                                <label className="col-md-5 catalog-label">{t("Need by Date")}</label>
                                                <label className="col-md-7 item-details-value" id={`NeedByD${this.state.headerdetails.Need_by_Date}${this.state.headerdetails.SDI_Requisition_Number}id`}>{this.state.headerdetails.Need_by_Date}</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="row">
                                                <label className="col-md-5 catalog-label">Machine Number</label>
                                                <label className="col-md-7 item-details-value" id={`MachineNo${this.state.headerdetails.Machine_Number}${this.state.headerdetails.SDI_Requisition_Number}id`}>{this.state.headerdetails.Machine_Number}</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 mb-3">
                                            <div className="row">
                                                <label className="col-md-5 catalog-label">{t("Submit")}{t("Date")}</label>
                                                <label className="col-md-7 item-details-value" id={`SubDate${this.state.headerdetails.Submit_Date}${this.state.headerdetails.SDI_Requisition_Number}id`}>{this.state.headerdetails.Submit_Date}</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-md-12 mb-3">
                                            <div className="row">
                                                <label className="col-md-5 notes-label catalog-label">{t("Customer Notes")}</label>
                                                <label className="col-md-7">
                                                    <textarea className="form-control custom-textarea" id={`Notes${this.state.headerdetails.Notes}${this.state.headerdetails.SDI_Requisition_Number}id`} readOnly defaultValue={this.state.headerdetails.Notes} />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 req-line">
                                    {this.bindReqApprovals()}
                                    </div>
                                    <div className="row mx-0">
                                        <div className="col-md-12  d-none">
                                            <div className="float-right total-order">
                                                Order Total <span className="price-rate">$8.4352</span>
                                            </div>
                                        </div>
                                        {/*<div className="col-md-12 my-3">
                                        <button className="btn btn-primary custom-btn-primary primary-btn float-right px-5">Recalculate</button>
                                    </div>*/}
                                        <div className="col-md-12 my-3">
                                            <button className="btn custom-btn-decline primary-btn float-right px-4 Zeus-Tab-Btn" onClick={() => this.declinemultipleclick(2)}>{t("Decline")}</button>
                                            <button className="btn custom-btn-approve float-right px-4 mr-2" onClick={() => this.approveClick([], false, true)}>{t("Approve")}</button>
                                            <button className="btn btn-secondary custom-btn-secondary secondary-btn float-right px-3 mr-2" onClick={() =>
                                                this.props.history.push({
                                                    pathname: '/needquote',
                                                })}>{t("Cancel")}</button>
                                        </div>
                                        <div className="err-msg text-danger w-100 ">{this.state.errorMessage}</div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Modal start*/}
                <div className="modal" id="declinereason" aria-modal="true" data-backdrop="static">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/*Modal Header*/}

                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Reason for Decline</Trans></h4>
                                <button type="button" className="btn close-btn" onClick={() => this.cancelclick()} data-dismiss="modal">
                                    X
                                          </button>
                            </div>
                            {/*Modal body*/}

                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12 float-left">
                                        <div className="col-md-12 col-lg-12 mb-3 float-left p-0">



                                            <label className="col-lg-12 col-md-12 float-left p-0 catalog-label form-label"><Trans>Reason</Trans><span className="color-manditory" id="CmntsMandatory">*</span></label>
                                            <div className="col-lg-12 col-md-12 float-left p-0 col-12">
                                                <select className="form-control" id="declreasondrop" value={this.state.reasonValue} onChange={this.HandleBtnTextchange}>

                                                    <option value={''}> {t("Select")}</option>
                                                    <option value={1} > {t("Too Expensive (Need Cheaper Quote)")}</option>
                                                    <option value={2} > {t("Wrong Quantities")}</option>
                                                    <option value={3} > {t("Wrong Item(s)")}</option>
                                                    <option value={4} > {t("Wrong Ship To Store")}</option>
                                                    <option value={5} > {t("No Longer Needed")}</option>
                                                </select>
                                            </div>
                                            {/*  <option value = {0}> {t("Select")}</option>*/}



                                        </div>
                                    </div>
                                    <div className="col-md-12 col-lg-12 moredetail-content">
                                        <label className="catalog-label d-block"><Trans>Comments</Trans></label>
                                        {this.state.reasonValue == "5"? <span className="color-manditory" id="CmntsMandatory">*</span>: null}
                                        <textarea className={`form-control custom-textarea ${this.state.inValidComments && this.state.Comments.length < 5 ? 'border-color-red' : ''}`} maxLength="254" id="decreasoncmt" placeholder="" onChange={(e) => this.HandleComments(e)} value={this.state.Comments}></textarea>
                                        <div>
                                            {this.state.inValidComments && this.state.Comments.length < 5 ? <label style={{ 'font-size': '15px', 'color': 'red' }} id="NotesLAbel">Please enter minimum 5 characters</label> : null}
                                            <span className="commentscount">{this.state.Comments.length}/254</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2 text-right p-0">
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-4 mt-3" onClick={() => this.cancelclick()} data-dismiss="modal"><Trans>Cancel</Trans></button>
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4 mt-3" id="subdecbtn" disabled={this.state.disabled_button} onClick={() => this.HandleDecSubClick()}><Trans>{this.state.declinereason}</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*WW-1044 - Limit Exceeded Modal Starts here*/}
                <div className="modal fade limit-exceeded-popup p-0 show " id="limit-exceeded" data-backdrop="static" data-keyboard="false"
                    tabIndex={-1} role="dialog" aria-modal="true" style={{ paddingLeft: '17px' }}>
                    <div className="modal-dialog modal-dialog-centered custom-bin-location-width" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center border-0">
                                <h5 className="modal-title" id="exampleModalLongTitle">Order limit exceeded</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close"><img src="images/close-icon.svg" alt="close" onClick={(e) => this.ExceededOkClick()} /></button>
                            </div>

                            <div className="modal-body py-4">
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <span className="font-14 font-regular custom-label-color mb-1">Order limit has exceeded and sent to next level approver</span>
                                    </div>

                                    <div className="col-md-12 mt-1">

                                        <div className="table-responsive popup-grid-scroll-style">
                                            <table className="table split-delv-table mb-0">
                                                <thead className="sticky-top">
                                                    <tr>
                                                        <th>Order #</th>
                                                        <th>Work order #</th>
                                                        <th>Approver name</th>
                                                        <th>Email ID</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr className="border-bottom">
                                                        <td>{this.state.NextApprDet.Order_No}</td>
                                                        <td>{this.state.NextApprDet.WO}</td>
                                                        <td>{this.state.NextApprDet.NextAprName}</td>
                                                        <td>{this.state.NextApprDet.NextAprEmail}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer border-0 d-flex justify-content-center mb-2">
                                <button className="btn btn-custom-primary font-14 font-medium px-4" data-dismiss="modal" onClick={(e) => this.ExceededOkClick()}>OK</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/*modal ends*/}
                {/*Approval comments modal starts here*/}
                <div class="modal fade approval-popup pl-0" id="ApprovalComments" tabindex="-1" role="dialog" aria-hidden="true" data-keyboard="false" data-backdrop="static">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content border-0">
                            <div class="modal-header sp-delv-header align-items-center">
                                <h5 class="modal-title" >Approval comments</h5>
                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.closeCommentsPopup()} >
                                    X
                                </button>
                            </div>

                            <div class="modal-body px-4">
                                <div class="row">

                                    <div class="col-md-12 mb-3">
                                        <label class="form-label catalog-label" for="comments">Comments</label>
                                        <textarea class="form-control" id="ApprvComment" placeholder="Enter comments" maxLength="254" value={this.state.Comments} onChange={(e) => this.HandleComments(e)} rows="3"></textarea>
                                    </div>

                                </div>
                            </div>

                            <div class="modal-footer border-0 pt-1 mb-2 px-4">
                                <button id="ApprvCommentCancel" class="btn btn-secondary custom-btn-secondary secondary-btn mr-2 px-4 py-2" data-dismiss="modal" onClick={() => this.closeCommentsPopup()}>Cancel</button>
                                <button id="ApprvCommentSave" class="btn btn-custom-primary font-15 font-medium px-4 py-2" onClick={() => this.approveClick("", false, false)}>Save</button>
                            </div>

                        </div>
                    </div>
                </div>
                {/*Approval comments modal ends here*/}
            </div>
        );

    };
}

export default withTranslation()(RequestorApprovalComponent);